// NOTE: keeping this here in case we ever want to override
// logging. The  callee part is trying to capture where
// log was called from. There doesn't appear to be a good way
// to capture this. If you just console.log it then 
// it says the console log originated from this file
// const logOverride = (...args) => {
// 	const err = new Error()
// 	const callee = err.stack.split('\n')[1]
// 	console.log(...args, callee)
// }

export const log = console.log.bind(window.console)

log.debug = console.debug.bind(window.console)

log.warn = console.warn.bind(window.console)

log.error = console.error.bind(window.console)

